import { z } from 'zod'

export const userApiProfileSchema = z
  .object({
    id: z.string(),
    email: z.string(),
    is_admin: z.boolean().default(false),
    first_name: z.string(),
    last_name: z.string(),
    monitor_enabled: z.boolean().default(false),
    ai_search_enabled: z.boolean().default(false),
    has_agreed_to_ps_terms: z.boolean().default(false),
  })
  .transform((data) => {
    const {
      is_admin,
      monitor_enabled,
      ai_search_enabled,
      has_agreed_to_ps_terms,
      first_name,
      last_name,
      ...rest
    } = data
    return {
      ...rest,
      firstName: first_name,
      lastName: last_name,
      isAdmin: is_admin,
      monitorEnabled: monitor_enabled,
      aiSearchEnabled: ai_search_enabled,
      hasAgreedToPSTerms: has_agreed_to_ps_terms,
    }
  })
  .describe('User Profile Schema')

export type UserType = z.infer<typeof userApiProfileSchema>

export const baseUserSchema = z
  .object({
    full_name: z.string(),
    id: z.string(),
  })
  .transform((user) => {
    const { full_name: fullName, ...userFields } = user
    return { ...userFields, fullName }
  })

export type BaseUser = z.infer<typeof baseUserSchema>

export const userCoreDetailsSchema = z
  .object({
    id: z.string(),
    email: z.email(),
    first_name: z.string(),
    last_name: z.string(),
  })
  .transform(({ id, email, first_name, last_name }) => ({
    id,
    email,
    fullName: `${first_name} ${last_name}`,
  }))

export type UserCoreDetails = z.infer<typeof userCoreDetailsSchema>
